'use client';

import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import { ImageOff } from 'lucide-react';

interface SafeImageProps {
  src?: string;
  alt: string;
  fill?: boolean;
  width?: number;
  height?: number;
  className?: string;
  priority?: boolean;
  sizes?: string;
  objectFit?: 'cover' | 'contain' | 'fill';
}

export default function SafeImage({
  src,
  alt,
  fill,
  width,
  height,
  className,
  priority,
  sizes,
}: SafeImageProps) {
  const [hasError, setHasError] = useState(false);

  if (!src || hasError) {
    return (
      <div
        className={`flex items-center justify-center bg-muted ${className ?? ''}`}
        style={fill ? { position: 'absolute', inset: 0 } : { width, height }}
        aria-label={alt}
      >
        <div className="flex flex-col items-center gap-1 opacity-40">
          <ImageOff size={28} color="var(--muted-foreground)" />
          <span className="text-xs text-muted-foreground font-medium">WINEWOOD</span>
        </div>
      </div>
    );
  }

  return (
    <AppImage
      src={src}
      alt={alt}
      fill={fill}
      width={!fill ? width : undefined}
      height={!fill ? height : undefined}
      className={className}
      priority={priority}
      sizes={sizes}
      fallbackSrc="/assets/images/no_image.png"
    />
  );
}